import * as React from 'react';
import { Edit16, Trash16 } from '@cian/ui-kit';
import * as styles from './Menu.css';

interface IMenuProps {
  onClickRename(): void;
  onClickRemove(): void;
}

export function Menu({ onClickRename, onClickRemove }: IMenuProps) {
  return (
    <div className={styles['container']}>
      <button className={styles['item']} onClick={onClickRename}>
        <span className={styles['icon']}>
          <Edit16 />
        </span>
        <span className={styles['text']}>Переименовать</span>
      </button>
      <button className={styles['item']} onClick={onClickRemove}>
        <span className={styles['icon']}>
          <Trash16 />
        </span>
        <span className={styles['text']}>Удалить</span>
      </button>
    </div>
  );
}
